import toggleMenu from "./partials/toggle-menu.js";
import filters from "./partials/filters.js";
import ajax from "./partials/ajax.js"; // Responsive menu

// Init responsive menu
toggleMenu();
filters();
ajax();

$("#open-menu").on("click", function () {
  $(this).hide();
  $("#close-menu").show();
  $("#mainNav").fadeIn();
});

$("#close-menu").on("click", function () {
  $(this).hide();
  $("#open-menu").show();
  $("#mainNav").fadeOut();
});

var expandButton = $("#expand-content");
var expandButtonText = $("#expand-text");
var expandableContent = $("#expandable-content");
var verticalPath = $("#vertical-path");
var animateTime = 500;

expandButton.on("click", function () {
  expandButton
    .parent()
    .toggleClass("bg-gradient-to-b from-transparent via-dark to-dark h-28");

  if (expandableContent.outerHeight() === 224) {
    expandButtonText.text("Visa mindre");
    verticalPath.hide();
    expandableContent.css({ height: "auto" });
  } else {
    expandButtonText.text("Läs mer");
    verticalPath.show();
    expandableContent.css({ height: "224" });
  }
});

function autoHeightAnimate(element, time) {
  var curHeight = element.outerHeight(), // Get Default Height
    autoHeight = element.css("height", "auto").outerHeight(); // Get Auto Height
  element.height(curHeight); // Reset to Default Height
  element.stop().animate({ height: autoHeight }, time); // Animate to Auto Height
}

$(".toggle-search").on("click", function () {
  if ($(window).width() > 1023) {
    $(".search-wrapper").css({ width: $(".search-form").width() + "px" });
  }
  $(".search-form").removeClass("opacity-0 pointer-events-none");
  $(this).addClass("opacity-0 pointer-events-none");
});

// Smooth scroll to IDs
$('a[href*="#"]')
  // Remove links that don't actually link to anything
  .not('[href="#"]')
  .not('[href="#0"]')
  .click(function (event) {
    // On-page links
    if (
      location.pathname.replace(/^\//, "") ==
        this.pathname.replace(/^\//, "") &&
      location.hostname == this.hostname
    ) {
      // Figure out element to scroll to
      var target = $(this.hash);
      target = target.length ? target : $("[name=" + this.hash.slice(1) + "]");
      // Does a scroll target exist?
      if (target.length) {
        // Only prevent default if animation is actually gonna happen
        event.preventDefault();
        $("html, body").animate(
          {
            scrollTop: target.offset().top - 200,
          },
          600,
          function () {
            // Callback after animation
            // Must change focus!
            var $target = $(target);
            $target.focus();
            if ($target.is(":focus")) {
              // Checking if the target was focused
              return false;
            } else {
              $target.attr("tabindex", "-1"); // Adding tabindex for elements not focusable
              $target.focus(); // Set focus again
            }
          }
        );
      }
    }
  });

$("#copy-url").click(function (e) {
  e.preventDefault();
  var clipboardText = $("#show-url").val();
  copyToClipboard(clipboardText);

  $(this).html(
    '<svg class="w-5 lg:w-6 h-5 lg:h-6 mr-1.5 -ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path></svg> Kopierat'
  );
});

function copyToClipboard(text) {
  var textArea = document.createElement("textarea");
  textArea.value = text;
  document.body.appendChild(textArea);

  textArea.select();

  try {
    var successful = document.execCommand("copy");
    var msg = successful ? "successful" : "unsuccessful";
    console.log("Copying text command was " + msg);
  } catch (err) {
    console.log("Oops, unable to copy");
  }

  document.body.removeChild(textArea);
}

$(".share").on("click", function () {
  const button = $(this);

  $("body").addClass("overflow-hidden");

  $(".share-title").text(button.data("share-title"));
  $(".share-url").val(button.data("share-url"));
  $(".share-image").attr("src", button.data("share-image"));
  $(".share-email").attr("href", button.data("share-email"));

  $("#share-modal").show();
});

$("#share-close").on("click", function () {
  $("#share-modal").hide();
  $("body").removeClass("overflow-hidden");
});

$("#share-overlay").on("click", function () {
  $("#share-modal").hide();
  $("body").removeClass("overflow-hidden");
});

$("#image-overlay").on("click", function () {
  $("#image-modal").hide();
  $("body").removeClass("overflow-hidden");
});

$(".open-image-modal").on("click", function () {
  $("body").addClass("overflow-hidden");
  $("#modal-media").html(
    '<img src="' + $(this).data("url") + '" class="block w-full h-auto" />'
  );
  $("#alt span").text($(this).data("alt"));
  $("#download").attr("href", $(this).data("url"));
  $("#download span").text("Ladda ner");
  $("#image-modal").show();
});

$(".open-video-modal").on("click", function () {
  $("body").addClass("overflow-hidden");
  const videoId = getId($(this).data("url"));
  const iframeMarkup =
    '<iframe class="w-full h-full absolute inset-0" width="560" height="315" src="//www.youtube.com/embed/' +
    videoId +
    '" frameborder="0" allowfullscreen></iframe>';

  $("#modal-media").html(
    '<div class="w-full pb-16/9 relative">' + iframeMarkup + "</div>"
  );
  $("#download").attr("href", $(this).data("url"));
  $("#download span").text("Titta på Youtube");
  $("#image-modal").show();
});

$("#image-modal-close").on("click", function () {
  $("#image-modal").hide();
  $("body").removeClass("overflow-hidden");
});

function getId(url) {
  const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
  const match = url.match(regExp);

  return match && match[2].length === 11 ? match[2] : null;
}
